export default function SectionHeader({ eyebrow, title, lead, align = "left", invert = false }) {
    return (
        <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
            {eyebrow && (
                <div
                    className={`eyebrow ${invert ? "!text-secondary" : ""}`}
                    data-testid="section-eyebrow"
                >
                    {eyebrow}
                </div>
            )}
            <h2
                className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight ${invert ? "text-white" : "text-foreground"}`}
                data-testid="section-title"
            >
                {title}
            </h2>
            {lead && (
                <p
                    className={`mt-5 text-base md:text-lg leading-relaxed ${invert ? "text-white/80" : "text-muted-foreground"}`}
                    data-testid="section-lead"
                >
                    {lead}
                </p>
            )}
        </div>
    );
}
